<script lang="ts">
    import { Link } from "svelte-routing";
    import Monster from './lib/monster';
    import { monster as monsterStore } from '../stores/monster';
    import MonsterProperties from './components/Properties/index.svelte';

    export let code: string;
    let name: string;
    let monster = new Monster(code);

    const handleClickRandomize = () => {
        monster = new Monster();
    };

</script>

<main>
    <MonsterProperties monster={monster} name={name}/>
    <button on:click={handleClickRandomize}>Randomize</button>
    <button on:click={() => monsterStore.set(monster.code)}>Claim</button>
    <Link to='battle'>Battle</Link>
</main>

<style>

</style>
